var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.checkRole('frisys_admin'))?_c('router-link',{attrs:{"to":"/competition/add"}},[_vm._v("Legg til nytt Stevne")]):_vm._e(),_c('CompetitionsList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }